// AUTO-GENERATED by scripts/generate-blog-data.mjs. Do not edit by hand.
// Re-run with: pnpm --filter @workspace/axle-inc run generate:blog
import type { BlogPostMeta } from "./posts";

export const POSTS_META_ES: BlogPostMeta[] = [
  {
    "slug": "best-trailer-jacks-electric-and-heavy-duty-2026-picks",
    "title": "Mejores Gatos para Remolques: Selecciones Eléctricas y de Trabajo Pesado para 2026",
    "category": "Buyer Guides",
    "date": "14 de marzo de 2026",
    "dateIso": "2026-03-14",
    "excerpt": "Vemos cientos de gatos para remolques pasar por el taller cada año. Aquí está lo que instalaríamos en un remolque en 2026, y lo que evitaríamos.",
    "readMinutes": 7
  },
  {
    "slug": "dexter-trailer-axle-alternatives-top-2026-options",
    "title": "Alternativas a los ejes de remolque Dexter: Mejores opciones para 2026",
    "category": "Axles & Suspension",
    "date": "22 de febrero de 2026",
    "dateIso": "2026-02-22",
    "excerpt": "Si está considerando una marca de ejes distinta a Dexter, aquí le explicamos qué vale realmente la pena y las compensaciones que vemos al llegar al taller.",
    "readMinutes": 8
  },
  {
    "slug": "repacking-wheel-bearings-on-boat-trailers",
    "title": "Reempaquetado de rodamientos de ruedas en remolques de embarcaciones (sin arruinarlos)",
    "category": "Service & Repair",
    "date": "30 de enero de 2026",
    "dateIso": "2026-01-30",
    "excerpt": "Los rodamientos de los remolques de barcos viven sumergidos en agua. Aquí explicamos cómo reempaquetarlos correctamente y los errores que vemos que destruyen rodamientos nuevos en una sola temporada.",
    "readMinutes": 9
  },
  {
    "slug": "choosing-the-right-trailer-axle-capacity",
    "title": "Cómo elegir la capacidad correcta del eje para remolque (sin gastar de más)",
    "category": "Buyer Guides",
    "date": "8 de enero de 2026",
    "dateIso": "2026-01-08",
    "excerpt": "Más grande no siempre es mejor. Así es como calculamos la capacidad de los ejes para nuestros clientes, y las matemáticas que realmente importan.",
    "readMinutes": 6
  },
  {
    "slug": "electric-vs-hydraulic-trailer-brakes",
    "title": "Frenos de remolque eléctricos frente a hidráulicos: ¿Cuál debería elegir?",
    "category": "Buyer Guides",
    "date": "10 de diciembre de 2025",
    "dateIso": "2025-12-10",
    "excerpt": "Los sistemas eléctricos e hidráulicos tienen su lugar. Aquí recomendamos cuál elegir según el remolque, el vehículo tractor y el caso de uso.",
    "readMinutes": 7
  },
  {
    "slug": "utility-trailer-care-a-practical-owner-s-guide",
    "title": "Remolques utilitarios: pisos, carga, compuertas y rampas",
    "category": "Service & Repair",
    "date": "16 de abril de 2021",
    "dateIso": "2021-04-16",
    "excerpt": "Mantenga el piso, equilibre la carga y el peso del enganche, inspeccione compuertas y rampas y adapte las sujeciones a los materiales transportados.",
    "readMinutes": 6
  },
  {
    "slug": "snowmobile-trailer-spring-prep",
    "title": "Cuidado del remolque de motos de nieve y almacenamiento",
    "category": "Service & Repair",
    "date": "9 de abril de 2021",
    "dateIso": "2021-04-09",
    "excerpt": "Proteja el remolque de la sal, revise los frenos en clima frío, asegure la carga y prepare neumáticos y rodamientos para guardarlo fuera de temporada.",
    "readMinutes": 4
  },
  {
    "slug": "buying-a-used-trailer-12-point-inspection",
    "title": "Compra de un remolque usado: inspección y documentos",
    "category": "Buyer Guides",
    "date": "2 de abril de 2021",
    "dateIso": "2021-04-02",
    "excerpt": "Inspeccione bastidor, soldaduras, suspensión, neumáticos, cableado y luces de un remolque usado y verifique sus documentos antes de comprarlo.",
    "readMinutes": 5
  },
  {
    "slug": "diy-trailer-repair-where-the-line-is",
    "title": "Reparaciones de remolque: cuándo acudir a un taller",
    "category": "Buyer Guides",
    "date": "26 de marzo de 2021",
    "dateIso": "2021-03-26",
    "excerpt": "Distinga las reparaciones que puede hacer el propietario de los trabajos de husillo, hidráulica y estructura que necesitan equipo y experiencia.",
    "readMinutes": 7
  },
  {
    "slug": "5-minute-pre-trip-inspection-that-catches-most-failures",
    "title": "Inspección antes del viaje: ruedas, luces y carga",
    "category": "Service & Repair",
    "date": "19 de marzo de 2021",
    "dateIso": "2021-03-19",
    "excerpt": "Revise tuercas, neumáticos, luces, cierres, cubos y peso sobre el enganche mediante una inspección del remolque antes de salir a la carretera.",
    "readMinutes": 6
  },
  {
    "slug": "winterizing-a-light-duty-trailer-2021-guide",
    "title": "Preparación del remolque ligero para el invierno",
    "category": "Service & Repair",
    "date": "12 de marzo de 2021",
    "dateIso": "2021-03-12",
    "excerpt": "Prepare neumáticos, rodamientos, retenes, conexiones eléctricas y suspensión para guardar el remolque en invierno con revisiones prácticas.",
    "readMinutes": 4
  },
  {
    "slug": "boat-trailer-maintenance-checklist-spring",
    "title": "Mantenimiento del remolque náutico: cubos y cableado",
    "category": "Service & Repair",
    "date": "5 de marzo de 2021",
    "dateIso": "2021-03-05",
    "excerpt": "Cuide los cubos después de sumergirlos, deje enfriar los rodamientos antes de botar la embarcación, proteja el cableado y programe el servicio anual.",
    "readMinutes": 4
  },
  {
    "slug": "trailer-wiring-4-flat-vs-7-pin-decoded",
    "title": "Cableado, conectores y sistema de emergencia del remolque",
    "category": "Service & Repair",
    "date": "26 de febrero de 2021",
    "dateIso": "2021-02-26",
    "excerpt": "Busque fallas de luces desde la conexión a tierra, proteja los contactos, evalúe luces LED e inspeccione el interruptor de frenado de emergencia.",
    "readMinutes": 5
  },
  {
    "slug": "a-frame-couplers-buying-and-installing",
    "title": "Inspección y reemplazo del acoplador de remolque",
    "category": "Trailer Parts",
    "date": "19 de febrero de 2021",
    "dateIso": "2021-02-19",
    "excerpt": "Inspeccione el desgaste del acoplador, verifique la bola de enganche, revise el actuador de frenos de inercia y sepa cuándo hace falta reemplazarlo.",
    "readMinutes": 7
  },
  {
    "slug": "tongue-jack-buying-guide-for-2021",
    "title": "Gatos de remolque: capacidad, cuidado y selección",
    "category": "Trailer Parts",
    "date": "12 de febrero de 2021",
    "dateIso": "2021-02-12",
    "excerpt": "Elija la capacidad del gato, compare opciones manuales y eléctricas y conozca su mantenimiento y las diferencias entre patas abatibles y fijas.",
    "readMinutes": 7
  },
  {
    "slug": "st-trailer-tires-buying-guide-for-2021",
    "title": "Guía de compra y mantenimiento de neumáticos de remolque",
    "category": "Trailer Parts",
    "date": "5 de febrero de 2021",
    "dateIso": "2021-02-05",
    "excerpt": "Revise la edad del neumático, elija su rango de carga, mantenga la presión en frío y planifique la revisión del repuesto y la rotación antes de viajar.",
    "readMinutes": 6
  },
  {
    "slug": "trailer-leaf-springs-replacement-and-diagnosis",
    "title": "Suspensión de remolque: desgaste y cambio de ballestas",
    "category": "Axles & Suspension",
    "date": "29 de enero de 2021",
    "dateIso": "2021-01-29",
    "excerpt": "Reconozca soportes desgastados, bujes dañados y ballestas rotas; conozca el alcance del reemplazo y las diferencias con la suspensión de torsión.",
    "readMinutes": 5
  },
  {
    "slug": "choosing-the-right-trailer-axle-capacity-up-to-10-000-lb",
    "title": "Capacidad de ejes: clasificaciones, placas y ejes tándem",
    "category": "Axles & Suspension",
    "date": "22 de enero de 2021",
    "dateIso": "2021-01-22",
    "excerpt": "Compare capacidades de ejes de hasta 10,000 lb, interprete la placa de especificaciones y conozca cómo el uso y los ejes tándem influyen en la elección.",
    "readMinutes": 4
  },
  {
    "slug": "electric-trailer-brakes-how-they-work-and-why-they-fail",
    "title": "Diagnóstico y servicio de frenos eléctricos de remolque",
    "category": "Service & Repair",
    "date": "15 de enero de 2021",
    "dateIso": "2021-01-15",
    "excerpt": "Entienda los frenos eléctricos del remolque, revise fallas de cableado y electroimanes y sepa cuándo conviene reemplazar el conjunto completo.",
    "readMinutes": 6
  },
  {
    "slug": "repacking-trailer-wheel-bearings-a-step-by-step-guide",
    "title": "Inspección y mantenimiento de rodamientos de remolque",
    "category": "Service & Repair",
    "date": "8 de enero de 2021",
    "dateIso": "2021-01-08",
    "excerpt": "Conozca las fallas de los rodamientos, cómo inspeccionar los cubos, qué incluye el servicio del taller y cuándo conviene realizar mantenimiento anual.",
    "readMinutes": 6
  }
];
